export default __webpack_public_path__ + "static/media/ivoy-logo.26f913cd.png";